import { Button } from "@msuite/ui/button";
import { useDisclosure } from "@msuite/ui/hooks";
import { Icon } from "@msuite/ui/icons";
import { useTranslation } from "@msuite/ui/localization";
import type { Enums } from "@msuite/utils/types";
import { Fragment } from "react";
import { Can } from "@/components/citadel/can";
import { AddReturnOrderModal } from "@/modals/stock/add-return-order-modal";
import { ReturnOrdersStateFilter } from "./return-orders-state-filter";

/** Props Interface */
interface ReturnOrdersMenuProps {
	onComplete?: () => Promise<unknown> | undefined;
	state: Enums<"returnOrderState"> | "all";
	onStateChange: (state: Enums<"returnOrderState"> | "all") => void;
}

export function ReturnOrdersMenu({ onComplete, state, onStateChange }: ReturnOrdersMenuProps) {
	/** Hooks */
	const { t } = useTranslation();
	const disclosure = useDisclosure();

	/** Render */
	return (
		<Fragment>
			<ReturnOrdersStateFilter
				state={state}
				onChange={onStateChange}
			/>
			<Can
				action="create"
				subject="Stock"
			>
				<Button
					icon={<Icon name="Plus" />}
					onClick={disclosure.onOpen}
					variant="primary"
				>
					{t("stock.add_return_order")}
				</Button>
			</Can>
			{disclosure.isOpen && (
				<AddReturnOrderModal
					isOpen={disclosure.isOpen}
					onClose={disclosure.onClose}
					onComplete={onComplete}
				/>
			)}
		</Fragment>
	);
}
